// This is just an example,
// so you can safely delete all default props below

export default {
    reset_password: 'Reset password',
    password: 'Password',
    repeat_password: 'Repeat password',
    set_password: 'Set password',
    succeeded: 'Password reset success',
    failed: 'Failed',
    error_password: 'The password must be at least 8 characters, and must contain uppercase / lowercase letters, numbers and symbols.',
    error_password_repeat: 'Password repeat must be the same as new password.',
}
